import { Nullable } from "@core/domain/types/nullable.type";
import { MedicalLeavePeriodDto } from "@entity/data/dto/employee/contracts/termination/medical-leave-period.dto";
import { MedicalLeavePeriod } from "@entity/domain/models/employee/contracts/termination/medical-leave-period.model";
import { validateSync } from "class-validator";
import { injectable } from "inversify";
import { DateTime } from "luxon";

@injectable()
export class MedicalLeavePeriodMapper {
    map(
        medicalLeavePeriodDto: MedicalLeavePeriodDto,
    ): Nullable<MedicalLeavePeriod> {
        const errors = validateSync(medicalLeavePeriodDto);

        if (errors.length > 0) {
            console.error(errors);
            return null;
        }

        return new MedicalLeavePeriod(
            medicalLeavePeriodDto.id,
            medicalLeavePeriodDto.termination ?? 0,
            DateTime.fromISO(medicalLeavePeriodDto.start_date),
            DateTime.fromISO(medicalLeavePeriodDto.end_date),
            Number(medicalLeavePeriodDto.company_salary_percentage),
            Number(medicalLeavePeriodDto.project_imputable_percentage),
            medicalLeavePeriodDto.observations,
        );
    }

    reverse(
        medicalLeavePeriod: MedicalLeavePeriod,
    ): Nullable<MedicalLeavePeriodDto> {
        const dto = new MedicalLeavePeriodDto();

        if (medicalLeavePeriod.id) {
            dto.id = medicalLeavePeriod.id;
        }
        dto.termination = medicalLeavePeriod.terminationId;
        dto.start_date = medicalLeavePeriod.startDate.toISODate() ?? "";
        dto.end_date = medicalLeavePeriod.endDate.toISODate() ?? "";
        dto.company_salary_percentage =
            medicalLeavePeriod.companySalaryPercentage.toString();
        dto.project_imputable_percentage =
            medicalLeavePeriod.projectImputablePercentage.toString();
        dto.observations = medicalLeavePeriod.observations;

        return dto;
    }
}
